import React, { FC } from "react";
import { ModalLayout } from "../Modal";

interface AdditionalCheckModalProps {
  onClose: () => void;
  isOpen: boolean;
  policy: string;
};

export const AdditionalCheckModal: FC<AdditionalCheckModalProps> = ({
  onClose,
  isOpen,
  policy,
}) => {
  return (
    <ModalLayout
			onClose={onClose}
			isOpen={isOpen}
      className="AdditionalCheckModal"
		>
      <div dangerouslySetInnerHTML={{ __html: policy }} />
    </ModalLayout>
  );
};
